<ng-container *ngIf="profile$ | async as profile">
    <ng-container *ngIf="profileFields$ | async as profileFields">
        <ng-container *ngIf="profileFields.length > 0">
            <section [id]="profile.Id">
                <h4 class="sh-accentuate-title">{{ profile.Name }}</h4>

                <dl class="sh-description-list">
                    <ng-container *ngFor="let profileField of profileFields$ | async">
                        <sh-generic-readonly-field
                            *ngIf="profileField.FieldDefinition; else notFound"
                            [profileField]="profileField"
                            [aiProfile]="aiProfile"
                            [record]="record"
                        ></sh-generic-readonly-field>

                        <ng-template #notFound>
                            <dt class="sh-description-list__term">{{ profileField.DisplayLabel }}</dt>
                            <dd class="sh-description-list__details">
                                {{ "form.error.fielddefinition-not-found" | translate: { id: profileField.FieldDefinitionId } }}
                            </dd>
                        </ng-template>
                    </ng-container>
                </dl>
            </section>
        </ng-container>
    </ng-container>
</ng-container>
